module.exports = __webpack_public_path__ + "static/media/transcription.d4d9150c.png";